var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('el-tag',{staticClass:"ml",attrs:{"size":"mini","type":_vm.type}},[_vm._v(_vm._s(_vm.value))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }